import React from 'react';
import { View, StyleSheet } from 'react-native';
import { Avatar } from 'stream-chat-react';
import { getStatusStyles } from '@/utils/statusStyles';
import { useChannelData } from '@/hooks/useChannelData';
import { UniverseStreamChannel } from '@/services/stream/types';

export const ChannelPreviewAvatar = (props: any) => {
  const { channel, name, image, size = 40 } = props;
  const { status } = useChannelData(channel as UniverseStreamChannel);
  const statusConfig = getStatusStyles(status);

  return (
    <View style={styles.container}>
      <Avatar name={name} image={image} size={size} />
      <View
        style={[
          styles.badge,
          { backgroundColor: statusConfig.backgroundColor },
        ]}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    position: 'relative',
  },
  badge: {
    position: 'absolute',
    top: 0,
    right: 0,
    width: 12,
    height: 12,
    borderRadius: 6,
    borderWidth: 2,
    borderColor: '#FFF',
    zIndex: 1,
  },
});
